<template>
  <div>
    <com-search :columns="searchColumn" @search="handleSearch"></com-search>
    <com-site-list model="shop" :default-params="defaultParams" ref="table"></com-site-list>
  </div>
</template>

<script>
export default {
  props: {
    defaultParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      searchColumn: [
        {
          label: '网点名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '绑定时间',
          prop: 'date',
          type: 'date'
        }
      ]
    }
  },
  methods: {
    handleSearch(val) {
      this.$refs.table.search(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
